var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('van-loading',{attrs:{"type":"spinner","color":"#1989fa"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }